// extracted by mini-css-extract-plugin
export var container = "actions-module--container--26ztj";
export var singleAction = "actions-module--singleAction--2aH_0";
export var title = "actions-module--title--1vL2b";
export var price = "actions-module--price--25e6s";
export var priceBefore = "actions-module--priceBefore--1wMuY";
export var more = "actions-module--more--1dS4y";
export var arrow = "actions-module--arrow--JGzYR";
export var addition = "actions-module--addition--1u73Q";